import { render, staticRenderFns } from "./VisualizarRelatorio.vue?vue&type=template&id=583c808e&scoped=true&"
import script from "./VisualizarRelatorio.vue?vue&type=script&lang=js&"
export * from "./VisualizarRelatorio.vue?vue&type=script&lang=js&"
import style0 from "./VisualizarRelatorio.vue?vue&type=style&index=0&id=583c808e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583c808e",
  null
  
)

export default component.exports